// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-logo.scss
 ** module id = 35
 ** module chunks = 0 1
 **/